// services/api/birebirOgretmenService.ts
import axios, { AxiosError } from "axios";
import { ApiResponse } from "../../types/BaseModals/ApiResponse";
import { API_URL } from "../../constants/API_URL";
import { BirebirOgretmenError } from "../../types/ErrorModals/BirebirOgretmenError";
import { BirebirOgretmenRequestModal } from "../../types/RequestModals/BirebirOgretmenRequestModal"; 
import { BirebirOgretmenApprovalModal, BirebirOgretmenResponseModal } from "../../types/modals";

export const getBirebirOgretmen = async (
  request: BirebirOgretmenRequestModal
): Promise<BirebirOgretmenResponseModal[]> => {
  try {
    const response = await axios.post<ApiResponse<BirebirOgretmenResponseModal[]>>(
      `${API_URL}/api/BirebirOgretmen/getBirebirOgretmen`,
      request
    );
    
    if (!response.data.success) {
      throw new Error(response.data.message);
    }
    
    return response.data.data!;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      
      if (axiosError.response?.status === 404) {
        throw {
          message: responseData?.message || "Birebir ders kaydı bulunamadı",
          correlationId: responseData?.correlationId,
        } as BirebirOgretmenError;
      }
      
      if (axiosError.response?.status === 400) {
        throw {
          message: responseData?.message || "Geçersiz istek",
          errors: responseData?.errors,
          correlationId: responseData?.correlationId,
        } as BirebirOgretmenError;
      }
      
      throw {
        message: responseData?.message || "Bir hata oluştu",
        correlationId: responseData?.correlationId,
        additionalData: responseData?.additionalData,
      } as BirebirOgretmenError;
    }
    
    throw {
      message: "Beklenmeyen bir hata oluştu",
    } as BirebirOgretmenError;
  }
};

// Add new functions for approval
export const approveLesson = async (
  request: BirebirOgretmenApprovalModal
): Promise<boolean> => {
  try {
    const response = await axios.post<ApiResponse>(
      `${API_URL}/api/BirebirOgretmen/approveLesson`,
      request
    );
    
    return response.data.success;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      
      throw {
        message: responseData?.message || "Ders onaylanırken bir hata oluştu",
        correlationId: responseData?.correlationId,
        errors: responseData?.errors,
        additionalData: responseData?.additionalData
      } as BirebirOgretmenError;
    }
    
    throw {
      message: "Beklenmeyen bir hata oluştu",
    } as BirebirOgretmenError;
  }
};

export const withdrawApproval = async (
  request: BirebirOgretmenApprovalModal
): Promise<boolean> => {
  try {
    const response = await axios.post<ApiResponse>(
      `${API_URL}/api/BirebirOgretmen/withdrawApproval`,
      request
    );
    
    return response.data.success;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ApiResponse>;
      const responseData = axiosError.response?.data;
      
      throw {
        message: responseData?.message || "Ders onayı geri çekilirken bir hata oluştu",
        correlationId: responseData?.correlationId,
        errors: responseData?.errors,
        additionalData: responseData?.additionalData
      } as BirebirOgretmenError;
    }
    
    throw {
      message: "Beklenmeyen bir hata oluştu",
    } as BirebirOgretmenError;
  }
};